import React from 'react';
import { useLocation, withRouter } from 'react-router';

import { DiningOptionBehavior } from 'src/apollo/onlineOrdering';
import { RequestContextProps } from 'src/lib/js/context';

import { SiteTheme } from 'shared/js/types';

import Meta from 'public/components/default_template/meta/Meta';
import Map from 'public/components/google_maps/Map';

type Props = RequestContextProps & {
  color?: string | null;
  siteTheme?: SiteTheme
};

export const MapPage = ({ staticContext, color, siteTheme }: Partial<Props>) => {
  // @ts-ignore
  const referrer = typeof window !== 'undefined' ? window.__REFERRER__ : staticContext?.req?.headers.referer;

  const { search } = useLocation();
  const params = new URLSearchParams(search);

  const selectedGuid = params.get('selectedGuid');
  const selectedDiningOptionParam = params.get('selectedDiningOption');
  const style = params.get('style');
  const locationGuids = params.getAll('guids');
  const orderPathPattern = params.get('orderPathPattern');
  const hostName = params.get('hostName');
  const sourceId = params.get('sourceId');
  if(!locationGuids?.length || !referrer) {
    if(staticContext) {
      staticContext.statusCode = 400;
    }

    return null;
  }

  const selectedDiningOption =
    selectedDiningOptionParam ?
      Object.values(DiningOptionBehavior).find(opt => opt.toString() === selectedDiningOptionParam) :
      undefined;

  return (
    <>
      <Meta primaryColor={color ?? undefined} icon="" domain="" siteTheme={siteTheme} />
      <Map
        orderPathPattern={orderPathPattern}
        hostName={hostName}
        markerStyle={style}
        sourceId={sourceId}
        useOrderFulfillment={true}
        targetOrigin={new URL(referrer).origin}
        locationGuids={locationGuids}
        selectedGuid={selectedGuid}
        color={color ?? undefined}
        selectedDiningOption={selectedDiningOption} />
    </>
  );
};

export default withRouter<Props, React.ComponentType<Props>>(MapPage);
